"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wait = exports.extractError = exports.throttle = exports.omit = exports.shuffleArray = exports.batchArray = exports.fromEntries = exports.entries = exports.assertUnreachable = exports.setIntersection = exports.toSnakeCase = exports.camelToSnake = exports.toCamelCase = exports.toQuery = exports.removeUndefined = exports.pick = exports.findUpdatedValues = exports.isObject = exports.arrayIntersection = exports.equal = exports.toMoney = exports.cancelDebounce = exports.debounce = exports.parseNum = exports.argMin = exports.stringCompare = exports.aggregate = exports.objectBy = exports.uniqueBy = exports.sortBy = exports.TimeUnits = void 0;
exports.search = search;
exports.notEmpty = notEmpty;
var TimeUnits;
(function (TimeUnits) {
    TimeUnits["MILLISECONDS"] = "ms";
    TimeUnits["SECONDS"] = "seconds";
    TimeUnits["MINUTES"] = "minutes";
    TimeUnits["HOURS"] = "hours";
    TimeUnits["DAYS"] = "days";
    TimeUnits["MONTHS"] = "months";
    TimeUnits["YEARS"] = "years";
})(TimeUnits || (exports.TimeUnits = TimeUnits = {}));
const sortBy = (arr, fn, options = { reverse: false }) => {
    const newArr = arr.slice();
    const lt = options.reverse ? 1 : -1;
    const gt = options.reverse ? -1 : 1;
    return newArr.sort((a, b) => {
        const aKey = fn(a);
        const bKey = fn(b);
        if (aKey < bKey) {
            return lt;
        }
        if (aKey > bKey) {
            return gt;
        }
        return 0;
    });
};
exports.sortBy = sortBy;
const uniqueBy = (arr, key) => {
    const seen = new Set();
    return arr.filter((item) => {
        const k = key(item);
        if (seen.has(k)) {
            return false;
        }
        seen.add(k);
        return true;
    });
};
exports.uniqueBy = uniqueBy;
const objectBy = (arr, fn, base = {}) => {
    return arr.reduce((acc, item) => {
        const key = fn(item);
        acc[key] = item;
        return acc;
    }, base);
};
exports.objectBy = objectBy;
const aggregate = (arr, fn, base = {}) => {
    for (const el of arr) {
        const key = fn(el);
        if (base[key] == null) {
            base[key] = [el];
        }
        else {
            base[key].push(el);
        }
    }
    return base;
};
exports.aggregate = aggregate;
const levenshtein = (s, t) => {
    if (!s.length)
        return t.length;
    if (!t.length)
        return s.length;
    const arr = [];
    for (let i = 0; i <= t.length; i++) {
        arr[i] = [i];
        for (let j = 1; j <= s.length; j++) {
            arr[i][j] =
                i === 0
                    ? j
                    : Math.min(arr[i - 1][j] + 1, arr[i][j - 1] + 1, arr[i - 1][j - 1] + (s[j - 1] === t[i - 1] ? 0 : 1));
        }
    }
    return arr[t.length][s.length];
};
const stringCompare = (refString, query) => {
    const snippets = window(refString, query);
    const scores = snippets.map((snippet, i, snippets) => {
        const base = levenshtein(snippet.toLowerCase(), query.toLowerCase());
        const startOfText = i == 0 || /^["'\- ]/.test(snippets[i - 1]) ? 0 : 0.5;
        const indexScore = i / (snippets.length + 1) / 2;
        return base + startOfText + indexScore;
    });
    const bestIndex = (0, exports.argMin)(scores);
    return {
        score: scores[bestIndex],
        start: bestIndex,
        end: bestIndex + snippets[bestIndex].length,
        match: snippets[bestIndex],
    };
};
exports.stringCompare = stringCompare;
const window = (text, query) => {
    const snippets = [];
    const queryLength = query.length;
    const textLength = text.length;
    if (queryLength > textLength) {
        return [text];
    }
    for (let i = 0; i < textLength - queryLength + 1; i++) {
        snippets.push(text.substring(i, i + queryLength));
    }
    return snippets;
};
const argMin = (arr) => {
    let minIndex = 0;
    for (let i = 1; i < arr.length; i++) {
        if (arr[i] < arr[minIndex]) {
            minIndex = i;
        }
    }
    return minIndex;
};
exports.argMin = argMin;
function search(arr, getText, query, options = { returnMeta: false }) {
    const results = arr.map((item) => {
        const snippets = window(getText(item), query);
        const scores = snippets.map((snippet, i, snippets) => {
            const base = levenshtein(snippet.toLowerCase(), query.toLowerCase());
            const startOfText = i == 0 || /^["'\- ]/.test(snippets[i - 1]) ? 0 : 0.5;
            const indexScore = i / (snippets.length + 1) / 2;
            return base + startOfText + indexScore;
        });
        const bestIndex = (0, exports.argMin)(scores);
        return {
            item,
            score: scores[bestIndex],
            start: bestIndex,
            end: bestIndex + snippets[bestIndex].length,
            match: snippets[bestIndex],
        };
    });
    const returned = results
        .filter((r) => r.score < 2)
        .sort((a, b) => a.score - b.score);
    return options.returnMeta ? returned : returned.map((x) => x.item);
}
function notEmpty(value) {
    return value !== null && value !== undefined;
}
const rightMostDecimalSeperator = (str) => {
    for (let i = str.length - 1; i >= 0; i--) {
        if (str[i] === ',') {
            return ',';
        }
        else if (str[i] === '.') {
            return '.';
        }
    }
    return '.';
};
const parseNum = (val, seperator) => {
    const sep = seperator !== null && seperator !== void 0 ? seperator : rightMostDecimalSeperator(val);
    const thousandsSep = sep === '.' ? ',' : '.';
    const transformed = val.split(thousandsSep).join('').split(',').join('.');
    return parseFloat(transformed);
};
exports.parseNum = parseNum;
const ids = {};
const debounce = (key, slowAction, time) => {
    const id = ids[key];
    clearTimeout(id);
    ids[key] = setTimeout(() => {
        delete ids[key];
        slowAction();
    }, time);
};
exports.debounce = debounce;
const cancelDebounce = (key) => {
    clearTimeout(ids[key]);
};
exports.cancelDebounce = cancelDebounce;
const toMoney = (num, options = {}) => {
    if (options.allowFractionalAmounts) {
        return Math.round(num * 10000) / 100;
    }
    return Math.round(num * 100);
};
exports.toMoney = toMoney;
const equal = (a, b) => {
    if ((0, exports.isObject)(a) && (0, exports.isObject)(b)) {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) {
            return false;
        }
        for (const key of aKeys) {
            if (!(0, exports.equal)(a[key], b[key])) {
                return false;
            }
        }
        return true;
    }
    return JSON.stringify(a) === JSON.stringify(b);
};
exports.equal = equal;
const arrayIntersection = (arr1, arr2) => {
    const s = new Set(arr1);
    return arr2.filter((e) => s.has(e));
};
exports.arrayIntersection = arrayIntersection;
const isObject = (obj) => {
    return obj !== null && typeof obj === 'object';
};
exports.isObject = isObject;
const findUpdatedValues = (prev, curr) => {
    const keys = Array.from(new Set(Object.keys(prev).concat(Object.keys(curr))));
    const updated = {};
    for (const key of keys) {
        if (!(0, exports.equal)(prev[key], curr[key])) {
            updated[key] = curr[key];
        }
    }
    return updated;
};
exports.findUpdatedValues = findUpdatedValues;
const pick = (value, keys) => {
    const x = {};
    for (const key of keys) {
        x[key] = value[key];
    }
    return x;
};
exports.pick = pick;
const removeUndefined = (obj) => {
    const newObj = Object.assign({}, obj);
    for (const key in newObj) {
        if (newObj[key] === undefined) {
            delete newObj[key];
        }
        else if (Array.isArray(newObj[key])) {
            newObj[key] = newObj[key].map((x) => {
                if (typeof x === 'object') {
                    return (0, exports.removeUndefined)(x);
                }
                return x;
            });
        }
        else if (typeof newObj[key] === 'object' && newObj[key] != null) {
            newObj[key] = (0, exports.removeUndefined)(newObj[key]);
        }
    }
    return newObj;
};
exports.removeUndefined = removeUndefined;
const toQuery = (val) => {
    const newObj = {};
    for (const key in val) {
        if (typeof val[key] === 'object') {
            newObj[key] = JSON.stringify(val[key]);
        }
        else if (typeof val[key] === 'undefined') {
            continue;
        }
        else {
            newObj[key] = `${val[key]}`;
        }
    }
    return `${new URLSearchParams(newObj)}`;
};
exports.toQuery = toQuery;
const capitalize = (string) => {
    if (string.length === 0)
        return '';
    return string[0].toUpperCase() + string.slice(1);
};
const snakeToCamel = (string) => {
    const [start, ...rest] = string.split('_');
    return start + rest.map(capitalize).join('');
};
const toCamelCase = (t) => {
    if (Array.isArray(t)) {
        return t.map((x) => (0, exports.toCamelCase)(x));
    }
    else if (t != null && t.constructor === Object) {
        return Object.fromEntries(Object.entries(t).map(([key, val]) => {
            const convVal = typeof val === 'object' ? (0, exports.toCamelCase)(val) : val;
            return [snakeToCamel(key), convVal];
        }));
    }
    return t;
};
exports.toCamelCase = toCamelCase;
const camelToSnake = (str) => {
    const chunks = [];
    let lastCut = 0;
    for (let i = 0; i < str.length; i++) {
        if (str[i] === str[i].toLocaleUpperCase()) {
            chunks.push(str.slice(lastCut, i));
            chunks.push(`_${str[i].toLocaleLowerCase()}`);
            lastCut = i + 1;
        }
    }
    chunks.push(str.slice(lastCut, str.length));
    return chunks.join('');
};
exports.camelToSnake = camelToSnake;
const toSnakeCase = (t) => {
    if (Array.isArray(t)) {
        return t.map((x) => (0, exports.toSnakeCase)(x));
    }
    else if (t != null && t.constructor === Object) {
        return Object.fromEntries(Object.entries(t).map(([key, val]) => {
            const convVal = typeof val === 'object' ? (0, exports.toSnakeCase)(val) : val;
            return [(0, exports.camelToSnake)(key), convVal];
        }));
    }
    return t;
};
exports.toSnakeCase = toSnakeCase;
const setIntersection = (a, b) => new Set([...a].filter((i) => b.has(i)));
exports.setIntersection = setIntersection;
const assertUnreachable = (x, error) => {
    throw new Error(error !== null && error !== void 0 ? error : `Should be Unreachable ${JSON.stringify(x)}`);
};
exports.assertUnreachable = assertUnreachable;
const entries = (a) => {
    return Object.entries(a);
};
exports.entries = entries;
const fromEntries = (a) => {
    return Object.fromEntries(a);
};
exports.fromEntries = fromEntries;
const batchArray = (arr, size) => {
    const newArr = [];
    const rounds = Math.ceil(arr.length / size);
    for (let i = 0; i < rounds; i++) {
        newArr.push(arr.slice(i * size, i * size + size));
    }
    return newArr;
};
exports.batchArray = batchArray;
const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
};
exports.shuffleArray = shuffleArray;
const omit = (obj, keys) => {
    return Object.fromEntries((0, exports.entries)(obj).filter(([key]) => !keys.includes(key)));
};
exports.omit = omit;
const throttle = (fn, options = { maxConcurrent: 5 }) => {
    const queue = [];
    let current = 0;
    const execute = (fn, ...args) => {
        return fn(...args)
            .then((r) => {
            if (queue.length === 0) {
                current -= 1;
            }
            else {
                queue.shift()();
            }
            return r;
        })
            .catch((err) => {
            if (queue.length === 0) {
                current -= 1;
            }
            else {
                queue.shift()();
            }
            throw err;
        });
    };
    return (...args) => {
        if (current < options.maxConcurrent) {
            current += 1;
            return execute(fn, ...args);
        }
        let resolve = (value) => { };
        const called = new Promise((r) => {
            resolve = r;
        });
        queue.push(resolve);
        const next = () => __awaiter(void 0, void 0, void 0, function* () {
            yield called;
            return yield execute(fn, ...args);
        });
        return next();
    };
};
exports.throttle = throttle;
const extractError = (err) => {
    if (err instanceof Error) {
        return err.message;
    }
    else if (typeof err === 'string') {
        return err;
    }
    try {
        return JSON.stringify(err);
    }
    catch (err) {
        console.error(err);
        return '';
    }
};
exports.extractError = extractError;
const wait = (ms) => new Promise((resolve, reject) => {
    setTimeout(resolve, ms);
});
exports.wait = wait;
//# sourceMappingURL=index.js.map